import SeoLandingTemplate, { SeoLandingPageData } from "@/components/marketing/SeoLandingTemplate";

const page: SeoLandingPageData = {
  path: "/star-method",
  title: "STAR Method Interview Examples",
  seoTitle: "STAR Method Interview Examples | HiredCoach",
  seoDescription:
    "Learn the STAR method with clear interview examples, common mistakes, and a practical CTA to turn your experience into stronger answers.",
  heroEyebrow: "Story structure",
  heroHeadline: "STAR helps when your stories keep turning into a mess",
  heroSubhead:
    "A lot of people have a decent example and still tell it badly. STAR is useful because it gives your answer rails. You stop circling. You get to the point.",
  heroPrimaryCta: "Build your STAR answer",
  heroPanelEyebrow: "What actually works",
  heroPanelTitle: "STAR is just structure",
  heroPanelBullets: [
    "Enough setup",
    "Clear ownership",
    "Real action",
    "Real result",
  ],
  heroPanelFooter: "That is why it works.",
  frameworkTitle: "How to use STAR without sounding robotic",
  frameworkBullets: [
    "Situation: give only the context they need.",
    "Task: make your responsibility obvious.",
    "Action: spend most of the answer here.",
    "Result: end with something concrete, not a shrug.",
  ],
  exampleTitle: "What a clean STAR answer sounds like",
  exampleBlocks: [
    "In a prior role our onboarding process was causing delays for new clients.",
    "I was responsible for improving activation speed without increasing support load.",
    "I mapped the biggest friction points, rewrote the kickoff checklist, and partnered with product to fix a confusing setup step.",
    "As a result, time-to-value dropped and support tickets during onboarding fell noticeably over the next quarter.",
  ],
  mistakesTitle: "Where STAR usually gets butchered",
  mistakes: [
    "You dump too much detail into the setup.",
    "You blur your action with what the team did.",
    "You forget the result, which is kind of the point.",
    "You say it like a checklist instead of a story.",
  ],
  ctaEyebrow: "Coach U + practice",
  ctaTitle: "Turn your experience into STAR answers",
  ctaBullets: [
    "Shape the story",
    "Tighten the action",
    "Land the result",
    "Say it until it sounds natural",
  ],
  ctaInfoCard: {
    title: "Coach U story-building content",
    path: "/public-learn",
    description: "Explore interview prep articles, then turn your strongest examples into usable answers.",
  },
  ctaActionTitle: "Build your STAR answer",
  ctaActionDescription: "Take the messy experience, give it structure, and practice it until it sounds natural.",
  relatedTitle: "More interview questions worth actually practicing",
  relatedLinks: [
    {
      title: "Behavioral Interview Questions and Answers",
      path: "/behavioral-interview-questions",
      description: "Review common behavioral interview questions, how to answer them well, and how to practice them with AI feedback.",
    },
    {
      title: "Common Interview Questions",
      path: "/common-interview-questions",
      description: "Use this hub page to prepare for the most common interview questions and jump into deeper answer guides and mock interview practice.",
    },
    {
      title: "Mock Interview Practice",
      path: "/mock-interview-practice",
      description: "Practice mock interviews with AI feedback, sharpen common interview answers, and turn Coach U frameworks into real interview reps.",
    },
  ],
  faqs: [
    { question: "What does STAR stand for in interviews?", answer: "Situation, Task, Action, and Result." },
    { question: "Should every behavioral answer use STAR?", answer: "Usually yes. It is the easiest way to keep a real story clear and useful." },
  ],
};

export default function StarMethodPage() {
  return <SeoLandingTemplate page={page} />;
}
